import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/interfaces/api-response';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class CguService {

    private apiURL = environment.appApiUrl + "cgu";
    
    constructor(private http: HttpClient) { }

    public getCgu(): Observable<ApiResponse> {
        return this.http.get<ApiResponse>(this.apiURL + "/get");
    }

    async validateCgu(): Promise<ApiResponse> {
        return this.http.post<ApiResponse>(this.apiURL + "/validate", null).toPromise();
    }
}
